var Shopify = Shopify || {};
var SHIP_PROD_HANDLE = SHIP_PROD_HANDLE || ship_ins.product.handle;
const SHIP_PROD_TYPE = 'Shipping-Insurance';
const FREQUENCIES = ['delivery every 1 month', 'Delivery every 2 months', 'Delivery every 3 months'];
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value)?.replace('.00', '');
};

var _utils = _utils || {
  async getCart() {
    return await fetch('/cart.js?delivery_internal=true').then((response) => {
                    return response.json();
                  }).then((cart) => {
                    return cart;
                  });
  },
  
  formatMoney(value) {
    return `${Shopify.formatMoney(value, Shopify.money_format)} ${Shopify.currency.active}`;
  },

  getShipVariant(cart) {
    var product = ship_ins.product;
    var variant = product.variants[0];
    
    function getVariant(cart) {
      //var cart_items = cart.items.filter(item => item.product_type !== SHIP_PROD_TYPE);
      var cart_items = cart.items.filter(item => item.handle !== SHIP_PROD_HANDLE);
      var cart_total_price = cart_items.reduce((sum, item) => sum + item.final_line_price , 0);
      
      if (cart_total_price < 7.5) {
        variant = null;
      }
      else if (cart_total_price >= 7.5 && cart_total_price < 7500) {
        variant = product.variants[0];
      }
      else if (cart_total_price >= 7500 && cart_total_price < 12500) {
        variant = product.variants[1];
      }
      else {
        variant = product.variants[2];
      }
      return variant;
    }

    if (!cart) {
      // if cart not passed, get cart data
      return new Promise((resolve) => {
        _utils.getCart().then((cart) => {
          resolve(getVariant(cart));
        });
      });
    } else {
      return getVariant(cart);
    }
  },

  getInterval(optionValue) {
    const intervalUnits = ['day', 'week', 'month', 'year'];
    const response = {
      frequency: 1,
      unit: 'day'
    };
      
    let frequency = optionValue.toLowerCase().match(/\d+/g);
      
    if (frequency != null) response.frequency = frequency[0];

    for(const index in intervalUnits) {
      const unit = intervalUnits[index];
      const regex = new RegExp(unit, 'g');

      if(optionValue.toLowerCase().match(regex)) {
        response.unit = unit;
        break;
      }
    }

    if(response.frequency > 1) response.unit += 's';
      
    return response;
  },

  getEligibleSellingPlan(product, selectedVariant, interval, intervalCount) {
    if(!product.selling_plan_groups || !interval || !intervalCount) return false;

    const skioSellingPlanGroups = product.selling_plan_groups;
    const availableSellingPlanGroups = skioSellingPlanGroups?.filter(selling_plan_group =>
      selling_plan_group.selling_plans.some(selling_plan =>
        selectedVariant.selling_plan_allocations.some(
          selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id
        )
      )
    );
        
    if(!availableSellingPlanGroups.length) return false;
    
    return availableSellingPlanGroups.flatMap((group) => group.selling_plans).find((selling_plan) => {
      const intervalOptions = _utils.getInterval(selling_plan.name);
      return intervalOptions.unit === interval.toLowerCase() && intervalOptions.frequency == intervalCount;
    });
  }
};

class InsuranceToggle extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector('input[type=checkbox]');
    if (this.checkbox) {
      this.checkbox.addEventListener('change', (evt) => {
        document.dispatchEvent(new CustomEvent('insuranceChange', { detail: {checked: evt.currentTarget.checked } }));
      })
    }
  }

  connectedCallback() {
    this.checkbox = this.querySelector('input[type=checkbox]');
  }
}

customElements.define('insurance-toggle', InsuranceToggle);

function checkShipIns() {
  // current cart state
  const cart = window.liquidAjaxCart.cart;

  const requests = [];

  // The variant ID of the promo-product, that should be automatically added
  let ins_variant = _utils.getShipVariant(cart);

  const item_ship_ins = cart.items.reduce((acc, item) => {
    if(item.product_type === SHIP_PROD_TYPE) return [...acc, item];
    return acc;
  }, []);

  const onlyDigitalItems = cart.items.every((item) => {
    return item.gift_card || !item?.requires_shipping || item.handle === SHIP_PROD_HANDLE;
  });

  let items_not_ins = cart.items.filter(item => item.product_type !== SHIP_PROD_TYPE);
  if ((onlyDigitalItems && !items_not_ins) || !cart?.requires_shipping || !items_not_ins ) {
    ship_ins_enabled = false;
    ins_variant = null;
  } else {
    ship_ins_enabled = true;
  }

  let selling_plan_id = null;
  let items_subscription = items_not_ins.find(item => item?.selling_plan_allocation !== undefined);
  if (items_subscription && ins_variant) {
    let interval = _utils.getInterval(items_subscription.selling_plan_allocation.selling_plan.name);
    if(interval) {
      let selling_plan = _utils.getEligibleSellingPlan(ship_ins.product, ins_variant, interval.unit, interval.frequency);

      if(selling_plan) {
        selling_plan_id = selling_plan.id;
      }
    }
  }

  // if no-ins variant, hide switch
  const $ship_variant_price = [...document.querySelectorAll('[data-ship-variant-price]')];
  $ship_variant_price.forEach((item) => {
    let $ship_ins_wrap = item.closest('.ship-insurance-wrap');
    if (!ins_variant) {
      $ship_ins_wrap.classList.add('hidden');
      $ship_ins_wrap.classList.remove('hidden');
    } else {
      // update price and show
      item.innerText = _utils.formatMoney(ins_variant.price)
      $ship_ins_wrap.classList.remove('hidden');
    }
  })
  const session_ins_disabled = JSON.parse(sessionStorage.getItem('ship-ins-declined')) || false;
  if (session_ins_disabled && ship_ins?.enabled === true) {
    $('.ship-insurance-wrap').removeClass('hidden');
  }

  if (ins_variant?.id && ship_ins_enabled && session_ins_disabled !== true) {
    // and the cart doesn't contain the promo-product —
    // add the promo-product automatically.
    const promoVariantLineItem = cart.items.find(lineItem => {
      return lineItem.variant_id === ins_variant.id;
    });
    const switchSellingPlan = promoVariantLineItem && selling_plan_id !== promoVariantLineItem?.selling_plan_allocation?.selling_plan?.id;
    //console.log(selling_plan_id, promoVariantLineItem?.selling_plan_allocation?.selling_plan?.id)

    if (!promoVariantLineItem) {
      requests.push({
        type: "add",
        body: {
          items: [{
            id: ins_variant.id,
            quantity: 1,
            selling_plan: selling_plan_id,
            properties: {}
          }]
        }
      });
    } else if (switchSellingPlan) {
      requests.push({
        type: "change",
        body: {
          id: promoVariantLineItem.key,
          selling_plan: selling_plan_id
        }
      });
    } else if (promoVariantLineItem.quantity > 1) {
      requests.push({
        type: "update",
        body: {
          updates: {
            [promoVariantLineItem.key]: 1
          }
        }
      });
    }
  }

  if (item_ship_ins.length) {
    const updates = item_ship_ins.reduce((acc, item) => {
      if ((ins_variant && ins_variant?.id != item.id) || !ins_variant || !ship_ins_enabled || session_ins_disabled === true) {
        return {...acc, [item.key]: 0};
      }
      return acc;
    }, {});
    if (Object.keys(updates).length) {
      requests.push({
        type: "update",
        body: {
          updates
        }
      });
    }
  }
  if (!requests.length) return;

  return { requests };
}

async function cartReload() {
  const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  var isCartPage = window.location.pathname.indexOf('/cart') !== -1;
  const cartItems = document.querySelector('cart-items');
  if (cartEl) {
    cartEl.style.setProperty('pointer-events', 'none');
    cartEl.classList.add('loading');
  }
  if (cartEl || (isCartPage && cartItems)) {
    if (cartEl) {
      cartEl.setActiveElement(document.activeElement);
    }

    const sections = cartEl ? cartEl.getSectionsToRender().map((section) => section.id) : [];
    if (isCartPage && cartItems) {
      const cart_sections = cartItems.getSectionsToRender().map((section) => section.section);
      sections.push(...cart_sections);
    }

    const body = JSON.stringify({
      updates: {},
      sections,
      sections_url: window.location.pathname,
    });
    await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.json();
          })
          .then((state) => {
            const parsedState = state;
            cartEl.dispatchEvent(new CustomEvent('renderContents', { detail: parsedState }));
            if (isCartPage && cartItems) {
              cartItems.dispatchEvent(new CustomEvent('renderContents', { detail: parsedState }));
            }
          })
          .catch(() => {
            if (cartEl) {
              cartEl.style.removeProperty('pointer-events');
              cartEl.classList.remove('loading');
            }
          })
          .finally(() => {
            if (cartEl) {
              cartEl.style.removeProperty('pointer-events');
              cartEl.classList.remove('loading');
            }
          });
      
  }
  
  const cart = window.liquidAjaxCart.cart;
  let ins_variant = _utils.getShipVariant(cart);

  const onlyDigitalItems = cart.items.every((item) => {
    return item.gift_card || !item?.requires_shipping || item.handle === SHIP_PROD_HANDLE;
  });

  let items_not_ins = cart.items.filter(item => item.product_type !== SHIP_PROD_TYPE);
  if ((onlyDigitalItems && !items_not_ins) || !cart?.requires_shipping ) {
    ins_variant = null;
  }
  // if no-ins variant, hide switch
  const $ship_variant_price = [...document.querySelectorAll('[data-ship-variant-price]')];
  $ship_variant_price.forEach((item) => {
    let $ship_ins_wrap = item.closest('.ship-insurance-wrap');
    if (!ins_variant) {
      $ship_ins_wrap.classList.add('hidden');
      $ship_ins_wrap.classList.remove('hidden');
    } else {
      // update price and show
      item.innerText = _utils.formatMoney(ins_variant.price)
      $ship_ins_wrap.classList.remove('hidden');
    }
  })
  let session_ins_disabled = JSON.parse(sessionStorage.getItem('ship-ins-declined')) || false;
  if (session_ins_disabled && ship_ins?.enabled === true) {
    $('.ship-insurance-wrap').removeClass('hidden');
  }
  //console.log('reload');
  return;
}

function getLiquidAjaxCart() {
  if (window.liquidAjaxCart?.init) {
    window.liquidAjaxCart.get();
  }
}

document.addEventListener("liquid-ajax-cart:request-start", () => {
  const cartDrawer =  document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.style.setProperty('pointer-events', 'none');
    cartDrawer.classList.add('loading');
  }
});
document.addEventListener("liquid-ajax-cart:request-end", () => {
  const cartDrawer =  document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.style.removeProperty('pointer-events');
    cartDrawer.classList.remove('loading');
  }
});

document.addEventListener("liquid-ajax-cart:init", () => {
  window.liquidAjaxCart.conf('mutations', [
    checkShipIns,
    cartReload
  ]);

  const events = 'cart:notification-open theme:product:added theme:cart:updated';
  events.split(' ').forEach((evt) => {
    document.addEventListener(evt, () => {
      getLiquidAjaxCart();
    });
  });

  document.addEventListener('insuranceChange', (evt) => {
    var isChecked = evt.detail?.checked;

    if (!isChecked) {
      localStorage.setItem("cart_has_ins", "false");
      // set session to indicate selection
      sessionStorage.setItem('ship-ins-declined', !isChecked);
    } else {
      sessionStorage.removeItem('ship-ins-declined');
    }
    getLiquidAjaxCart();
  })
})
